const getAdvancedSearchActiveFilterCount = ({
  typeItems = [],
  colorItems = [],
  selectedFacets,
  isReadyToShipActive,
  minWidth,
  maxWidth,
}) => {
  let count = 0;

  count += typeItems.filter(item => item.isRefined).length;
  count += colorItems.filter(item => item.isRefined).length;

  if (selectedFacets) {
    count += Object.values(selectedFacets).reduce(
      (facetCount, values) => facetCount + (values?.size ?? 0),
      0
    );
  }

  if (isReadyToShipActive) {
    count += 1;
  }

  if (minWidth || maxWidth) {
    count += 1;
  }

  return count;
};

export default getAdvancedSearchActiveFilterCount;
